/* Printavelle: gemensam köpmodul för alla Design it-verktyg.
   Laddar upp kundens tryckfil, lägger rätt variant i varukorgen och
   sparar en förhandsvisning som visas i varukorgen. */
(() => {
  const ENDPOINT = 'https://yqlambkbanhfepsxzxux.supabase.co/functions/v1/printavelle-design';
  const FRAME_LABEL = {
    none: 'No frame', '': 'No frame', black: 'Black frame', white: 'White frame',
    natural: 'Oak frame', oak: 'Oak frame', wood: 'Oak frame', dark: 'Dark wood frame'
  };
  const SIZE_CM = {
    '21x30': [21, 29.7], '30x40': [30, 40], '40x50': [40, 50], '50x70': [50, 70], '70x100': [70, 100]
  };
  const MAX_PIXELS = 30e6;

  function money(cents, currency, locale) {
    try { return new Intl.NumberFormat(locale || 'sv-SE', { style: 'currency', currency: currency || 'SEK' }).format(cents / 100); }
    catch { return (cents / 100).toFixed(2) + ' ' + (currency || 'SEK'); }
  }

  function printCanvas(draw, size) {
    const cm = SIZE_CM[size] || SIZE_CM['30x40'];
    const inches = [cm[0] / 2.54, cm[1] / 2.54];
    let dpi = Math.min(300, Math.floor(Math.sqrt(MAX_PIXELS / (inches[0] * inches[1]))));
    dpi = Math.max(150, dpi);
    const target = document.createElement('canvas');
    target.width = Math.round(inches[0] * dpi);
    target.height = Math.round(inches[1] * dpi);
    draw(target.getContext('2d'), target.width, target.height);
    return { canvas: target, dpi };
  }

  function toBlob(canvas, type, quality) {
    return new Promise((resolve, reject) => canvas.toBlob(b => b ? resolve(b) : reject(new Error('export')), type, quality));
  }

  function readAsDataUrl(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result));
      reader.onerror = () => reject(new Error('read'));
      reader.readAsDataURL(blob);
    });
  }

  async function mount(panel, options) {
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const dataEl = panel.querySelector('.pv-order-data');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent || '{}');
    const variants = product.variants || [];
    if (!variants.length) { panel.hidden = true; return; }

    const priceEl = panel.querySelector('.pv-order-price');
    const summaryEl = panel.querySelector('.pv-order-summary');
    const button = panel.querySelector('.pv-order-add');
    const status = panel.querySelector('.pv-order-status');

    const sizeSel = panel.querySelector('.pv-order-size');
    const frameSel = panel.querySelector('.pv-order-frame');

    function current() {
      const size = String((sizeSel && sizeSel.value) || options.getSize() || '30x40');
      const frameKey = String((frameSel && frameSel.value) || options.getFrame() || 'none').toLowerCase();
      const frame = FRAME_LABEL[frameKey] || 'No frame';
      const frameNames={none:panel.dataset.none,'':panel.dataset.none,white:panel.dataset.frameWhite,black:panel.dataset.frameBlack,oak:panel.dataset.frameOak,natural:panel.dataset.frameOak,wood:panel.dataset.frameOak,dark:panel.dataset.frameDark};
      const displayFrame=frameNames[frameKey] || panel.dataset.none;
      const variant = variants.find(v => v.option1 === size && v.option2 === frame && v.available);
      return { size, frame, displayFrame, variant };
    }

    if (sizeSel) sizeSel.addEventListener('change', () => refresh());
    if (frameSel) frameSel.addEventListener('change', () => refresh());

    function refresh() {
      const { size, frame, displayFrame, variant } = current();
      if (summaryEl) summaryEl.textContent = size.replace('x', '×') + ' cm · ' + displayFrame;
      if (priceEl) priceEl.textContent = variant ? money(variant.price, product.currency, product.locale) : '—';
      if (button) button.disabled = !variant;
      if (status && !variant) status.textContent = panel.dataset.unavailable || '';
    }

    panel.pvRefresh = refresh;
    refresh();

    button.addEventListener('click', async () => {
      if (options.validate && !options.validate()) return;
      const { size, frame, displayFrame, variant } = current();
      if (!variant) return;
      button.disabled = true;
      const busy = panel.dataset.busy;
      status.textContent = busy;
      try {
        const { canvas, dpi } = printCanvas(options.draw, size);
        const printBlob = await toBlob(canvas, 'image/jpeg', 0.94);
        const dataUrl = await readAsDataUrl(printBlob);
        canvas.width = 1; canvas.height = 1;

        const response = await fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'upload', imageBase64: dataUrl, filename: 'printavelle-' + (options.tool || 'design') + '-' + size + '.jpg', source: options.tool || 'design' })
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.error || 'upload');

        const properties = {
          '_pv_design_path': result.path,
          '_pv_preview': result.previewUrl || '',
          '_pv_dpi': String(dpi),
          '_pv_edit': (window.location.pathname + window.location.search).slice(0, 180),
          'Size': size.replace('x', '×') + ' cm',
          'Frame': frame,
          'Design': options.label || panel.dataset.design
        };
        const extra = options.details ? options.details() : null;
        if (extra) Object.keys(extra).forEach(k => { if (extra[k]) properties[k] = String(extra[k]).slice(0, 200); });

        const add = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties }] })
        });
        if (!add.ok) throw new Error('cart');
        status.textContent = panel.dataset.added;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(() => { window.location.href = window.Shopify.routes.root + 'cart'; }, 700);
      } catch (error) {
        console.error('PVOrder add failed', error);
        status.textContent = panel.dataset.failed;
        button.disabled = false;
      }
    });
  }

  window.PVOrder = { mount, FRAME_LABEL };
  document.dispatchEvent(new CustomEvent('pv-order:ready'));
})();
